(function(angular, console) {
    'use strict';

    angular.module('wtApp.wtTracking.errorHandler').decorator('$exceptionHandler', $exceptionHandlerFactory);

    /**
     * @ngdoc object
     * @name $exceptionHandler
     * @description $exceptionHandler decorator that catches any unhandled exceptions in the application and logs them
     */
    $exceptionHandlerFactory.$inject = ['$delegate', '$injector'];
    function $exceptionHandlerFactory($exceptionHandler, $injector) {
        return function wtExceptionHandler(error, cause) {
            $exceptionHandler(error, cause);

            try {
                const wtErrorPigeon = $injector.get('wtErrorPigeon');
                wtErrorPigeon.sendException(error);
            } catch (caughtError) {
                // Something went terribly wrong
                if (console && typeof console.error === 'function') {
                    console.error(caughtError);
                }
            }
        };
    }
})(window.angular, window.console);
